import React from "react";
import { useGetMyOrdersQuery } from "../slices/orderApiSlice";
import { useDispatch } from "react-redux";
import { logout } from "../slices/authSlice";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";

const MyOrdersScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: orders, isLoading } = useGetMyOrdersQuery();

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  const cardColors = ["#dff9fb", "#f6e58d", "#ffbe76", "#7ed6df", "#f0932b"];

  if (isLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (!orders || orders.length === 0) {
    return (
      <Container className="text-center mt-5">
        <Alert variant="info">No orders found.</Alert>
        <Button variant="secondary" onClick={logoutHandler} className="mt-3">
          Logout
        </Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <Button variant="outline-primary" onClick={() => navigate("/Home")}>
            ← Back to Home
          </Button>
        </Col>
      </Row>

      <h2 className="mb-4 text-center">My Orders</h2>

      <Row xs={1} sm={2} md={3} lg={3} className="g-4">
        {orders.map((order, index) => {
          const bgColor = cardColors[index % cardColors.length];

          return (
            <Col key={order._id}>
              <Card style={{ backgroundColor: bgColor }}>
                <Card.Body>
                  <Card.Title>Order #{order._id.slice(-6)}</Card.Title>
                  <Card.Text>
                    <strong>Status:</strong> {order.status}
                  </Card.Text>
                  <Card.Text>
                    <strong>Total:</strong> ₹{order.totalAmount.toFixed(2)}
                  </Card.Text>
                  <Card.Text>
                    <strong>Items:</strong> {order.products.length}
                  </Card.Text>
                  <Button
                    variant="dark"
                    onClick={() =>
                      navigate(`/userOrder/${order._id}`) // Adjust path as needed
                    }
                  >
                    View Order Details
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default MyOrdersScreen;
